import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle } from '@coreui/react-pro'
import './CodeSearchBox.scss'

export default function CodeSearchBox({
  placeholder,
  shouldFocus,
  searchText,
  setSearchText,
  currentCodeTemplate,
  setCurrentCodeTemplate,
  type,
}) {
  const providerCodeTemplates = useSelector((state) => state.user?.providerCodeTemplates)

  const focusRef = useRef(null)
  useEffect(() => {
    if (shouldFocus && focusRef.current) {
      // timeout because they way CoreUI handles modals,
      // there is a delay in mounting the input
      setTimeout(() => {
        focusRef.current?.focus()
      }, 1000)
    }
  }, [shouldFocus])

  return (
    <div className={'CodeSearchBox'}>
      <div className={'input-holder'}>
        <i
          className="fa-sharp fa-magnifying-glass icon-search-encounter"
          style={{ fontSize: '0.85em', marginTop: '3px' }}
        ></i>

        <input
          ref={focusRef}
          type="text"
          className="input-search"
          placeholder={placeholder || 'Search...'}
          onChange={(e) => setSearchText(e.target?.value)}
          value={searchText}
        />
        {searchText && (
          <div className="close-icon-container-practice">
            <i
              className="far fa-xmark"
              style={{ fontSize: '1.1em', cursor: 'pointer' }}
              onClick={() => {
                setSearchText('')
              }}
            ></i>
          </div>
        )}
      </div>
      <CDropdown className={'toggle-dropdown'}>
        <CDropdownToggle
          color="none"
          className={'toggle-button'}
          style={{ padding: currentCodeTemplate ? '4px' : '2px' }}
        >
          {currentCodeTemplate || (
            <i className={`fa-regular fa-star`} style={{ fontSize: '1.1em' }}></i>
          )}
        </CDropdownToggle>
        <CDropdownMenu className="popup-menu">
          <CDropdownItem
            onClick={() => {
              setCurrentCodeTemplate('Favorites')
            }}
          >
            Favorites
          </CDropdownItem>

          {providerCodeTemplates
            .toSorted((a, b) => (a.name > b.name ? 1 : -1))
            ?.filter((pct) => pct.enabled && pct[type]?.length > 0)
            ?.map((code, index) => (
              <CDropdownItem
                key={index}
                onClick={() => {
                  setCurrentCodeTemplate(code.name)
                }}
              >
                {code.name}
              </CDropdownItem>
            ))}
          {currentCodeTemplate && (
            <CDropdownItem
              onClick={() => {
                setCurrentCodeTemplate(null)
              }}
              style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              Clear
              <i className="far fa-xmark" style={{ fontSize: '1.1em', marginTop: '2px' }}></i>
            </CDropdownItem>
          )}
        </CDropdownMenu>
      </CDropdown>
    </div>
  )
}
